export default "__VITE_ASSET__McprlwoL__"